import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import BodyContainer from "../ui/BodyContainer";
import makeStyles from "@material-ui/core/styles/makeStyles";
import emailOptOutStyles from "../styles/emailOptOutStyles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Services from "../services/services";
import CustomButton from "../ui/viewEventUi/CustomButton";
import toast, { Toaster } from "react-hot-toast";
import {
  getUserBrowserStorage,
  clearAllBrowserStorage,
  removeSessionItem,
} from "../constants";

const useStyles = makeStyles((theme) => emailOptOutStyles(theme));

function EmailOptOut() {
  const classes = useStyles();
  let { userId } = useParams();
  const history = useHistory();
  const [userDetail, setUserDetail] = useState({
    fullname: "",
    email: "",
    isSubscriptionActive: false,
  });
  const userDetails = JSON.parse(getUserBrowserStorage("userDetails"));

  const logoutFunc = async () => {
    try {
      const res = await Services.logout(userDetails?.userId);
      if (res.data.responseCode === 200) {
        clearAllBrowserStorage();
        removeSessionItem("prevBoxSeatDetails");
        // toast.success(res.data.message);
        // history.replace('/login');
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Unknown error!");
    }
  };

  const getUserDetails = async () => {
    try {
      const res = await Services.view_user(userId);
      const details = res.data.userDetails[0];

      setUserDetail({
        fullname:
          details.firstName + (details.lastName ? ` ${details.lastName}` : ""),
        email: details.email,
        isSubscriptionActive: details.isSubscriptionActive,
      });
    } catch (error) {}
  };

  useEffect(() => {
    userDetails?.userId && logoutFunc();
    getUserDetails();
    return () => {};
  }, [userDetails?.userId]);

  const submitUnsubscribe = async () => {
    try {
      const res = await Services.unsubscribe_mails(userId);
      if (res.data.responseCode === 200) {
        toast.success(res.data.message);
        history.replace("/");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Unknown error!");
    }
  };
  return (
    <BodyContainer title="Unsubscribe">
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <Typography variant="h5" gutterBottom>
            
            {userDetail.isSubscriptionActive ? (
            'On confirmation, you will be unsubscribed from future emails'
          ) : (
            'You will be unsubscribed from future emails'
          )
          }
          </Typography>
          <div className={classes.emailTextContainer}>
            <Typography variant="body1">Email Address: &nbsp;</Typography>
            <Typography variant="subtitle2">{userDetail.email}</Typography>
          </div>
          <div className={classes.horizontalLine} />
          <Typography variant="subtitle1" gutterBottom>
          {userDetail.isSubscriptionActive ? (
            `Dear ${userDetail.fullname}, we are sad to see you go!`
          ) : (
            `Dear ${userDetail.fullname}, You already unsubscribed!`
          )
          }
            
          </Typography>
          {userDetail.isSubscriptionActive ? (
            <CustomButton
              btnStyle={classes.submitBtn}
              clickHandle={submitUnsubscribe}
              btnText={"Unsubscribe"}
            />
          ) : null}
        </Paper>
      </Grid>
      <Toaster position="top-center"></Toaster>
    </BodyContainer>
  );
}

export default EmailOptOut;
